import {useOfficeTranslation} from "i18n/OfficeTranslation";

export const useInvoiceFormatting = () => {
    const {intlLocale} = useOfficeTranslation();
    const number = new Intl.NumberFormat(intlLocale, {minimumFractionDigits: 2, maximumFractionDigits: 2});
    return {
        currency: (value: number) => `€ ${number.format(value)}`,
        date: (value: Date) => value.toLocaleDateString(intlLocale, {day: "numeric", month: "short", year: "numeric"}),
        quantity: (value: number) => value.toLocaleString(intlLocale),
    };
};
